import { render, staticRenderFns } from "./CommentTombstone.vue?vue&type=template&id=03d11426&scoped=true"
var script = {}
import style0 from "./CommentTombstone.vue?vue&type=style&index=0&id=03d11426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d11426",
  null
  
)

export default component.exports